import { ApiError } from '@/lib/api';

/**
 * Map an ingest/rescan/discover failure to action-oriented copy
 * (A2F-1115 / A2F-659).
 *
 * Structured `ApiError` codes get tailored guidance; everything else — incl.
 * the 403 `PermissionError`, whose message already names the required role,
 * and the `*_not_found` codes, whose backend message is already specific —
 * falls back to the backend's own message, then `fallback`.
 *
 * Shared by the ingest/rescan paths (and available to other storage-backed
 * callers) so the same root cause maps to the same copy everywhere.
 */
export function friendlyStorageError(e: unknown, fallback: string): string {
  const code = e instanceof ApiError ? e.code : null;
  switch (code) {
    case 'storage_unconfigured':
      return 'Set up SharePoint storage in Manage Project first.';
    case 'graph_token_expired':
      return 'Your Microsoft session expired. Sign in again to continue.';
    case 'graph_permission_denied':
      return "Chrona can't access this SharePoint location. Ask an admin to check the app's Graph API permissions.";
    default:
      return e instanceof Error && e.message ? e.message : fallback;
  }
}
